import { useCallback } from 'react'

/*
  Safe Console.log Sink that will only log in dev mode
*/
export const useConsoleLogger = () => {
  const logToConsole = useCallback(
    (message: any, payload?: { [key: string]: any }) => {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log(message, payload)
      }
    },
    [],
  )

  return {
    logToConsole,
  }
}
